/**
 * pushNotification.ts
 *
 * Push Notifications Models
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

export interface ApnsPushInfo {
  deviceToken: string,
  bundleID: string,
  pushType: "apns"
}

export enum NotificationType {
  unknown = "unknown",
  MSG = "NEW_MESSAGE",
  READ = "READ", // should be unused in browser
  HUDDLE_START = "HUDDLE_START",
  HUDDLE_REQ_RESULT = "HUDDLE_REQ_RESULT",
  HUDDLE_REQ_TIMEOUT = "HUDDLE_REQ_TIMEOUT"
}

export interface PushNotificationData {
  accountID: string,
  groupID: string,
  isBackground: boolean,
  videoSessionUUID?: string,

  //client-side only
  groupname: string
}

export interface PushNotificationMessageData extends PushNotificationData {
  accountID: string,
  groupID: string,
  msgID: string,
  noteType: NotificationType.MSG | NotificationType.HUDDLE_START,
  fromUserID?: string,
  fromDeviceID?: string,
  fromUser?: string,
  toUserID?: string
}

export interface PushNotificationGroupData extends PushNotificationData {
  noteType: NotificationType.HUDDLE_REQ_RESULT,
  fromUserID: string,
  fromDeviceID: string,
  toUserID?: string,
  isBackground: boolean,
  result: string
}

export interface HuddleRequestTimeout {
  accountID: string,
  groupID: string,
  noteType: NotificationType.HUDDLE_REQ_TIMEOUT
}

export interface PushNotification {
  notification: {
    title: string,
    body?: string,
    icon?: string
  },
  msgData?: PushNotificationMessageData | PushNotificationGroupData
}
